import { Mixins, Component } from 'vue-property-decorator'
import cms from '@/cms'
import { Action, Getter, Mutation } from 'vuex-class'
import { RouteGuardHandler } from './route-guard-handler'
import { ThemeHandler } from '../mixins/theme-handler'

@Component
export class AppHandler extends Mixins(RouteGuardHandler, ThemeHandler) {
  @Mutation('SET_CAMPAIGN_ID') setCampaignId!: (id: number) => void

  @Action('LOAD_CAMPAIGN') loadCampaign!: () => Promise<void>
    @Action('LOAD_TRACKS') loadTracks!: () => Promise<void>
    @Action('LOAD_JOURNEY_STATE') loadJourneyState!: () => void

  @Action('AUTH_SPOTIFY_HANDLE_ACCESS_TOKEN') authSpotifyHandleToken!: () => Promise<boolean>

  @Getter authToken!: string
  @Getter authIsNew!: boolean
  @Getter authEmail!: string
  @Getter isAuthenticated!: boolean

  isCmsReady = false

  async $appInit ({ editor = true } = {}) {
    // This init procedure is somewhat complicated because
    // we're not using CMS to handle auth
    // 1. Init CMS without tracking so campaign, translations, etc is loaded
    await cms.init({ iframeEnabled: editor, tracking: false })

    // Wait for first token before load campaign
    if (cms.campaign.appId) {
      // TODO: Don't keep appId in store, use cms.campaign.appId directly
      this.setCampaignId(parseInt(cms.campaign.appId))
      // 2. Check for user login in callback URL or storage and load the current user
      // CMS must be initialized before this so we have access to the campaign ID
      await this.authSpotifyHandleToken()
      // 3. Init tracking module which fires the page_meta event (with logged in user info if any)
      cms.tracking.init()
      // 4. Event listener to fire virtual_pageview on route changes
      this.$router.afterEach(() => {
        cms.tracking.trackRouteChange()
      })

      await this.loadCampaign()
      await this.loadTracks()
      this.loadJourneyState()

      this.$routeGuardApp()
      this.$themeInsertFont()
    }

    console.log('cms', cms.newsletter, cms.newsletter.enabled)
    if (cms.newsletter.enabled) {
      cms.newsletter.initBanner()
    }
    this.isCmsReady = true
  }
}
